import type OpenAI from 'openai';
import snakecaseKeys from 'snakecase-keys';

/**
 * Stream transformer to convert the incoming data to OpenAI format
 * The stream that we are getting from our API service is not in the format
 * that OpenAI expects. This transformer will convert the incoming data
 * into SSE format so that we can re-use OpenAI client
 *
 * Keep it as it is for now, we will refactor it later
 * and cover with unit tests
 */
export const createTransformationStream = () => {
  return new TransformStream({
    transform(chunk, controller) {
      const content = new TextDecoder().decode(chunk as any);

      if (content) {
        transformStream(content, controller);
      }
      if (!content) {
        controller.enqueue(null);
      }
    },
  });
};

export function transformStream(content: string, controller: TransformStreamDefaultController<any>) {
  if (content) {
    const convertedLines = convertLines(content);
    controller.enqueue(convertedLines);
  }

  if (!content) {
    controller.enqueue(null);
  }
}

function convertLines(chunkContents: string) {
  const convertedLineObjects: OpenAI.ChatCompletion[] = chunkContents
    .split('\n')
    .filter((line) => line)
    .map((line) => JSON.parse(line))
    .map((line) => snakecaseKeys(line))
    .map((line) => {
      return {
        id: 'chatcmpl-9cbwdzY5YG89O1gp3pD8Ae4xQR3i2', // Fake
        object: 'chat.completion.chunk', // Fake
        system_fingerprint: 'fp_0338b7694d', // Fake
        ...line,
        choices: line.choices.length
          ? [
              {
                finish_reason: line.choices[0].finish_reason || null,
                index: 0, // Fake
                ...line.choices[0],
                delta: {
                  ...line.choices[0].delta,
                  ...(line.choices[0].delta.tool_calls
                    ? {
                        tool_calls: [
                          {
                            index: 0, // Fake
                            ...line.choices[0].delta.tool_calls[0],
                          },
                        ],
                      }
                    : {}),
                },
              },
            ]
          : [],
      } satisfies OpenAI.ChatCompletion;
    });

  const isFinished = convertedLineObjects.some((line) => line.choices.some((choice: any) => !!choice.finish_reason));

  const convertedLines = [
    ...convertedLineObjects.map((lineObject) => `data: ${JSON.stringify(lineObject)}`),
    isFinished ? 'data: [DONE]' : '',
  ];

  return convertedLines.join('\n\n');
}
